/* Bundle builder: modal size/colour picker for one Kaching deal bar (quantity break + free gifts).
   Markup and copy: snippets/c-bundle-builder.liquid + locales (bundle_builder.*).
   The modal is built from Kaching's deal + product JSON; confirmed choices are written into Kaching's own
   per-item selects, so Kaching still adds the products to the cart and applies the bundle discount. */
(function() {
  // Swatch colours from the design, keyed by the option value's name in the shop's default language.
  // Other colours fall back to the Shopify swatch colour, then grey.
  const SWATCH_COLORS = {
    zwart: '#1a1a1a',
    wit: '#f7f6f2',
    beige: '#e3c9ae',
    rood: '#c3252f',
    roze: '#f2b6c6',
    blauw: '#1f2b5c',
    navy: '#1f2b5c',
    grijs: '#9b9b9b',
    sort: '#1a1a1a',
    hvid: '#f7f6f2',
    'rød': '#c3252f',
    'lyserød': '#f2b6c6',
    rosa: '#f2b6c6',
    'blå': '#1f2b5c',
    'grå': '#9b9b9b'
  };
  // Palette order from the design; colours not listed keep Kaching's order after these
  const COLOR_ORDER = ['zwart', 'sort', 'wit', 'hvid', 'beige', 'rood', 'rød', 'roze', 'lyserød', 'rosa', 'blauw', 'blå', 'navy'];
  // BH sizes run to XXL, slips to 2XL
  const SIZE_ALIASES = { XXL: '2XL', '2XL': 'XXL' };
  // Option names in the shop's default language; the colour option is also recognised by its Shopify swatches
  const COLOR_OPTION_PATTERN = /kleur|colou?r|couleur|farbe|farve/i;
  const SIZE_OPTION_PATTERN = /maat|omvang|size|taille|gr(ö|oe)(ß|ss)e|st(ø|o)rrelse/i;
  // One element per item holding its colour/size selects: the bar's variant rows (BHs), then its free gifts (slips)
  const ITEM_ROW_SELECTOR = '.kaching-bundles__bar-variants .kaching-bundles__bar-variant-selector-wrapper, .kaching-bundles__free-gift';

  function init() {
    const dialog = document.querySelector('.c-bundle-builder');
    const template = document.querySelector('[data-c-bundle-bar-template]');
    if (!dialog || !template) return;

    const dealBarId = dialog.dataset.dealBarId;
    const freeMainItems = Number(dialog.dataset.freeMainItems) || 0;
    const bundle = readBundle(dealBarId, dialog);
    if (!bundle) return;

    const { groups, items } = bundle;
    const groupList = [groups.main, groups.gift].filter(Boolean);
    // Each column keeps its palette open on its own active slot (as in the design); only the last used column highlights it
    let focusGroup = groups.main;
    let confirmed = false;

    function findBars() {
      return [...document.querySelectorAll(`.kaching-bundles__bar[data-deal-bar-id="${CSS.escape(dealBarId)}"]`)];
    }

    function selectedBar() {
      return findBars().find(bar => bar.classList.contains('kaching-bundles__bar--selected'));
    }

    function isFree(item) {
      return item.group.key === 'gift' || item.index >= item.group.items.length - freeMainItems;
    }

    function isAvailable(group, color, size) {
      return group.product.variants.some(variant =>
        variant.availableForSale &&
        (color == null || variant.options[group.colorIndex] === color) &&
        (size == null || variant.options[group.sizeIndex] === size)
      );
    }

    function matchSize(group, size) {
      if (group.sizes.includes(size)) return size;
      return group.sizes.includes(SIZE_ALIASES[size]) ? SIZE_ALIASES[size] : null;
    }

    function setItemSize(item, size) {
      item.size = size;
      if (item.color && !isAvailable(item.group, item.color, size)) item.color = null;
    }

    function selectGroupSize(group, size) {
      group.size = size;
      group.sizeAutofilled = false;
      group.items.forEach(item => setItemSize(item, size));

      // Prefill the slip size from the BH size until the customer picks one themselves
      const gift = groups.gift;
      if (group.key === 'main' && gift && (gift.size == null || gift.sizeAutofilled)) {
        const giftSize = matchSize(gift, size);
        if (giftSize) {
          gift.size = giftSize;
          gift.sizeAutofilled = true;
          gift.items.forEach(item => setItemSize(item, giftSize));
        }
      }
    }

    function nextEmptyItem(group, from) {
      const start = from ? from.index : 0;
      for (let offset = 0; offset < group.items.length; offset++) {
        const item = group.items[(start + offset) % group.items.length];
        if (!item.color) return item;
      }
      return null;
    }

    function fillSwatch(swatch, group, name) {
      const color = group.colors.find(value => value.name === name)?.hex || '#cccccc';
      swatch.style.setProperty('--swatch-color', color);
      swatch.classList.add('is-filled');
      swatch.classList.toggle('is-light', isLight(color));
    }

    function el(tag, className, content) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (content != null) element.textContent = content;
      return element;
    }

    function renderSizes(group) {
      const container = group.element.querySelector('[data-c-bundle-sizes]');
      container.replaceChildren(...group.sizes.map(size => {
        const wrapper = el('div', 'c-bundle-builder__size');
        wrapper.appendChild(el('span', 'c-bundle-builder__size-tag', text(dialog, 'textSizeTag')));
        const chip = el('button', 'c-bundle-builder__chip', size);
        chip.type = 'button';
        chip.dataset.focusKey = `${group.key}-size-${size}`;
        chip.setAttribute('aria-pressed', String(group.size === size));
        chip.disabled = !isAvailable(group, null, size);
        chip.addEventListener('click', () => {
          selectGroupSize(group, size);
          render();
        });
        wrapper.appendChild(chip);
        return wrapper;
      }));

      const note = group.element.querySelector('[data-c-bundle-size-note]');
      if (note) {
        note.hidden = !group.sizeAutofilled;
        note.textContent = text(group.element, 'textSizeNote', { size: group.size });
      }

      const perItemToggle = group.element.querySelector('[data-c-bundle-per-item]');
      if (perItemToggle) {
        perItemToggle.textContent = group.perItemSizes
          ? text(group.element, 'textSameSize', { count: group.items.length })
          : text(group.element, 'textPerItem');
      }
    }

    function renderSlots(group) {
      const container = group.element.querySelector('[data-c-bundle-slots]');
      container.replaceChildren(...group.items.map(item => {
        const number = item.index + 1;
        const slot = el('div', 'c-bundle-builder__slot');
        const button = el('button', 'c-bundle-builder__slot-button');
        button.type = 'button';
        button.dataset.focusKey = `${group.key}-slot-${item.index}`;
        button.classList.toggle('is-active', item === group.activeItem && group === focusGroup);
        button.setAttribute('aria-label', `${text(group.element, 'textSlotLabel', { number })}: ${item.color || text(dialog, 'textChoose')}`);

        const swatch = el('span', 'c-bundle-builder__swatch');
        if (item.color) fillSwatch(swatch, group, item.color);
        button.append(
          el('span', 'c-bundle-builder__slot-number', `#${number}`),
          swatch,
          el('span', 'c-bundle-builder__slot-label', item.color || text(dialog, 'textChoose'))
        );
        button.addEventListener('click', () => {
          group.activeItem = item;
          focusGroup = group;
          render();
        });
        slot.appendChild(button);

        if (group.perItemSizes) {
          const select = el('select', 'c-bundle-builder__slot-size');
          select.setAttribute('aria-label', text(group.element, 'textSizeSelect', { number }));
          select.dataset.focusKey = `${group.key}-slot-size-${item.index}`;
          group.sizes.forEach(size => select.appendChild(new Option(size, size, false, item.size === size)));
          select.addEventListener('change', () => {
            setItemSize(item, select.value);
            // A slip size picked by hand isn't overwritten by the BH size any more
            group.sizeAutofilled = false;
            const sizes = new Set(group.items.map(groupItem => groupItem.size));
            group.size = sizes.size === 1 ? [...sizes][0] : null;
            render();
          });
          slot.appendChild(select);
        }

        // Rendered for every slot so all slots keep the same height, as in the design
        const freeTag = el('span', 'c-bundle-builder__free-tag', text(dialog, 'textFree'));
        freeTag.classList.toggle('is-hidden', !isFree(item));
        slot.appendChild(freeTag);
        return slot;
      }));
    }

    function renderPalette(group) {
      const palette = group.element.querySelector('[data-c-bundle-palette]');
      const activeItem = group.activeItem;
      palette.hidden = !activeItem;
      if (!activeItem) return;

      palette.querySelector('[data-c-bundle-palette-title]').textContent =
        text(group.element, 'textPaletteTitle', { number: activeItem.index + 1 });
      palette.querySelector('[data-c-bundle-swatches]').replaceChildren(...group.colors.map(({ name }) => {
        const option = el('button', 'c-bundle-builder__color');
        option.type = 'button';
        option.dataset.focusKey = `${group.key}-color-${name}`;
        option.setAttribute('aria-pressed', String(activeItem.color === name));
        option.disabled = !isAvailable(group, name, activeItem.size);
        const swatch = el('span', 'c-bundle-builder__swatch');
        fillSwatch(swatch, group, name);
        option.append(swatch, el('span', 'c-bundle-builder__color-name', name));
        option.addEventListener('click', () => {
          activeItem.color = name;
          group.activeItem = nextEmptyItem(group, activeItem);
          focusGroup = group;
          render();
        });
        return option;
      }));
    }

    function renderFooter() {
      const bar = findBars()[0];
      dialog.querySelector('[data-c-bundle-price]').textContent = barText(bar, '.kaching-bundles__bar-price');
      dialog.querySelector('[data-c-bundle-full-price]').textContent = barText(bar, '.kaching-bundles__bar-full-price');

      const cta = dialog.querySelector('[data-c-bundle-confirm]');
      const groupWithoutSize = groupList.find(group => group.items.some(item => !item.size));
      const missingColors = items.filter(item => !item.color).length;
      cta.disabled = Boolean(groupWithoutSize || missingColors);
      if (groupWithoutSize) {
        cta.textContent = text(groupWithoutSize.element, 'textSizeMissing');
      } else if (missingColors) {
        cta.textContent = missingColors === 1
          ? text(dialog, 'textColorsMissingOne')
          : text(dialog, 'textColorsMissingOther', { count: missingColors });
      } else {
        cta.replaceChildren(
          el('span', 'c-bundle-builder__cta-check', '✓'),
          el('span', null, text(dialog, 'textConfirm'))
        );
        cta.firstChild.setAttribute('aria-hidden', 'true');
      }
    }

    function render() {
      // The dialog is rebuilt on every change, so put focus back on the control that had it
      const focusKey = dialog.contains(document.activeElement) ? document.activeElement.dataset.focusKey : null;
      groupList.forEach(group => {
        // A size change can clear a colour, which reopens the palette on that slot
        group.activeItem = group.activeItem || nextEmptyItem(group);
        renderSizes(group);
        renderSlots(group);
        renderPalette(group);
      });
      renderFooter();
      if (focusKey) dialog.querySelector(`[data-focus-key="${CSS.escape(focusKey)}"]`)?.focus();
    }

    function openModal(bar) {
      // Selecting the bar makes Kaching render the per-item selects the choices are written to
      if (bar && !bar.classList.contains('kaching-bundles__bar--selected')) {
        bar.querySelector('input[type="radio"]')?.click();
      }
      groupList.forEach(group => {
        group.activeItem = nextEmptyItem(group);
      });
      focusGroup = groupList.find(group => group.activeItem) || groups.main;
      render();
      dialog.showModal();
      document.documentElement.classList.add('c-bundle-builder-open');
    }

    function applyChoices(bar) {
      if (bar.querySelectorAll(ITEM_ROW_SELECTOR).length !== items.length) return false;
      items.forEach((item, index) => {
        const { product, colorIndex, sizeIndex } = item.group;
        // Kaching can re-render a row after a change, so look the row up again for every item
        const row = bar.querySelectorAll(ITEM_ROW_SELECTOR)[index];
        setSelect(row, product.options[colorIndex].name, item.color);
        setSelect(row, product.options[sizeIndex].name, item.size);
      });
      return true;
    }

    async function confirmChoices() {
      const bar = selectedBar();
      if (!bar) return;
      const ready = await waitFor(() => bar.querySelectorAll(ITEM_ROW_SELECTOR).length === items.length);
      if (!ready || !applyChoices(bar)) return;
      // Look up the buy buttons before Kaching re-renders the bar (a detached bar has no section to search)
      const section = bar.closest('.shopify-section') || document;
      confirmed = true;
      dialog.close();
      enhanceBars();
      addToCart(section);
    }

    // Confirming the bundle also adds it to the cart. Clicking the real add to cart button keeps the theme's
    // loader and cart drawer, Kaching's own add flow and the re-sync in the click handler below.
    async function addToCart(section) {
      // The main buy buttons block, not the hidden product form or the sticky quick add (same form id prefix).
      // The theme renders the button as type="" (a submit button by default), so check the property, not the attribute.
      const findButton = () => {
        const isSubmit = button => button.type === 'submit' && button.form?.getAttribute('id')?.startsWith('product-form-');
        const buttons = [
          ...section.querySelectorAll('.product-info__buy-buttons button'),
          ...document.querySelectorAll('.product-info__buy-buttons button'),
        ];
        return buttons.find(isSubmit);
      };
      // Give Kaching a moment to process the select changes before submitting
      await new Promise(resolve => setTimeout(resolve, 150));
      const ready = await waitFor(() => {
        const button = findButton();
        return button && !button.disabled;
      });
      // No button: the choices are already in Kaching's selects, so the customer can still add to cart themselves
      if (!ready) return;
      findButton().click();
    }

    function enhanceBars() {
      findBars().forEach(bar => {
        bar.classList.add('c-bundle-bar-host');
        let ui = bar.querySelector('.c-bundle-bar');
        if (!ui) {
          const main = bar.querySelector('.kaching-bundles__bar-main');
          if (!main) return;
          ui = template.content.firstElementChild.cloneNode(true);
          main.after(ui);
        }

        const price = barText(bar, '.kaching-bundles__bar-price');
        const fullPrice = barText(bar, '.kaching-bundles__bar-full-price');
        setText(ui.querySelector('[data-c-bundle-price]'), price);
        setText(ui.querySelector('[data-c-bundle-full-price]'), fullPrice);
        setText(ui.querySelector('[data-c-bundle-subtitle]'), barText(bar, '.kaching-bundles__bar-subtitle'));

        // Once confirmed, the subtitle and button make way for a summary of the choice
        ui.querySelector('[data-c-bundle-subtitle]').hidden = confirmed;
        ui.querySelector('.c-bundle-bar__button').hidden = confirmed;
        ui.querySelector('[data-c-bundle-summary]').hidden = !confirmed;
        groupList.forEach(group => {
          setText(ui.querySelector(`[data-c-bundle-summary-line="${group.key}"]`), confirmed ? summaryLine(group) : '');
        });

        const saving = ui.querySelector('[data-c-bundle-saving]');
        // A fixed percentage from the section setting wins over the one calculated from Kaching's prices
        const percentage = Number(dialog.dataset.savingPercentage) || Math.round((1 - parsePrice(price) / parsePrice(fullPrice)) * 100);
        saving.hidden = !(percentage > 0 && percentage < 100);
        setText(saving, text(dialog, 'textSaving', { percentage }));

        renderThumbs(ui.querySelector('[data-c-bundle-thumbs]'));
      });
    }

    // "5 BH's · maat M — 2× Zwart, Beige, Wit, Rood"; with mixed sizes each colour gets its size: "2× Zwart (M), Beige (L)"
    function summaryLine(group) {
      const sizes = new Set(group.items.map(item => item.size));
      const sameSize = sizes.size === 1;
      const counts = new Map();
      group.items.forEach(item => {
        const label = sameSize ? item.color : `${item.color} (${item.size})`;
        counts.set(label, (counts.get(label) || 0) + 1);
      });
      const colors = [...counts].map(([label, count]) => (count > 1 ? `${count}× ${label}` : label)).join(', ');
      return sameSize
        ? text(group.element, 'textSummary', { count: group.items.length, size: [...sizes][0], colors })
        : text(group.element, 'textSummaryMixed', { count: group.items.length, colors });
    }

    function renderThumbs(container) {
      const sources = items.map(item => imageFor(item));
      const signature = sources.join('|');
      if (container.dataset.signature === signature) return;
      container.dataset.signature = signature;

      container.replaceChildren(...items.flatMap((item, index) => {
        const thumb = el('img', 'c-bundle-bar__thumb');
        thumb.src = sources[index];
        thumb.alt = item.color ? `${item.group.product.title} - ${item.color}` : item.group.product.title;
        thumb.width = 60;
        thumb.height = 76;
        const startsGift = index > 0 && item.group !== items[index - 1].group;
        return startsGift ? [el('span', 'c-bundle-bar__plus', '+'), thumb] : [thumb];
      }));
    }

    function imageFor(item) {
      const { product, colorIndex } = item.group;
      const variant = item.color && product.variants.find(variant => variant.options[colorIndex] === item.color && variant.image);
      return variant ? variant.image : product.image;
    }

    // Copy with runtime values: counts, the BH offer and the slips' value
    const giftValue = groups.gift
      ? formatMoney(groups.gift.product.variants[0].price * groups.gift.items.length, dialog.dataset.moneyFormat)
      : '';
    groupList.forEach(group => {
      group.element.querySelectorAll('[data-c-bundle-text]').forEach(element => {
        element.textContent = fillText(element.dataset.cBundleText, {
          count: group.items.length,
          paid: group.items.length - freeMainItems,
          free: freeMainItems,
          value: giftValue
        });
      });
    });

    dialog.addEventListener('click', event => {
      // Clicks on the backdrop land on the dialog itself
      if (event.target === dialog || event.target.closest('[data-c-bundle-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('c-bundle-builder-open'));
    dialog.querySelector('[data-c-bundle-confirm]').addEventListener('click', confirmChoices);
    groupList.forEach(group => {
      group.element.querySelector('[data-c-bundle-per-item]').addEventListener('click', () => {
        group.perItemSizes = !group.perItemSizes;
        if (group.perItemSizes) {
          // Every dropdown shows a real size: start empty slots on the column's size, or the first available one
          const startSize = group.size || group.sizes.find(size => isAvailable(group, null, size));
          group.items.forEach(item => {
            if (!item.size) setItemSize(item, startSize);
          });
          group.size = new Set(group.items.map(item => item.size)).size === 1 ? startSize : group.size;
        } else if (group.size) {
          // Back to one size for the column: apply it to every item again
          selectGroupSize(group, group.size);
        }
        render();
      });
    });

    // Capture phase on window so the click never reaches Kaching's bar handlers
    window.addEventListener('click', event => {
      if (!event.target.closest) return;

      const openButton = event.target.closest('[data-c-bundle-open]');
      if (openButton) {
        event.preventDefault();
        event.stopPropagation();
        openModal(openButton.closest('.kaching-bundles__bar'));
        return;
      }

      // Add to cart with this bundle selected: open the modal first, or re-sync the choices in case Kaching re-rendered its selects.
      // getAttribute: a product form's `id` property is shadowed by its <input name="id">
      const submitButton = event.target.closest('button');
      const formId = submitButton?.type === 'submit' ? submitButton.form?.getAttribute('id') : null;
      if (!formId || !formId.startsWith('product-form-')) return;
      const bar = selectedBar();
      if (!bar) return;
      if (!confirmed || !applyChoices(bar)) {
        event.preventDefault();
        event.stopPropagation();
        openModal(bar);
      }
    }, true);

    // Kaching renders the bars after load and re-renders them on every change. Only its app block is watched
    // (it's server-rendered, so it exists before Kaching does), not the whole page, e.g. the cart drawer redrawing.
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        enhanceBars();
      });
    }).observe(bundle.root, { childList: true, subtree: true, characterData: true });
    enhanceBars();
  }

  function readBundle(dealBarId, dialog) {
    let dealBar = null;
    let root = document.body;
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(script => {
      const bar = parseJson(script)?.dealBars?.find(dealBar => dealBar.id === dealBarId);
      if (!bar) return;
      dealBar = bar;
      root = script.closest('.shopify-app-block') || document.body;
    });
    if (!dealBar || !dealBar.quantity) return null;

    const products = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach(script => {
      const product = parseJson(script);
      if (!product) return;
      products[String(product.id)] = product;
      if (script.dataset.main === 'true') products.main = product;
    });

    // Same order as Kaching renders the selects: the page's product (the BH) once per quantity, then the free gift products (the slips)
    const entries = [
      ...Array.from({ length: dealBar.quantity }, () => ({ key: 'main', product: products.main })),
      ...(dealBar.freeGifts || [])
        .filter(gift => gift.giftType === 'product')
        .map(gift => ({ key: 'gift', product: products[gift.productGID.split('/').pop()] }))
    ];

    const groups = { main: null, gift: null };
    const items = [];
    for (const { key, product } of entries) {
      if (!product) return null;

      if (!groups[key]) {
        const { colorIndex, sizeIndex } = findOptionIndexes(product);
        if (colorIndex === -1 || sizeIndex === -1) return null;
        groups[key] = {
          key,
          product,
          colorIndex,
          sizeIndex,
          colors: sortColors(product.options[colorIndex].optionValues),
          sizes: product.options[sizeIndex].optionValues.map(value => value.name),
          size: null,
          sizeAutofilled: false,
          perItemSizes: false,
          activeItem: null,
          items: [],
          element: dialog.querySelector(`[data-c-bundle-group="${key}"]`)
        };
      }

      const item = { group: groups[key], index: groups[key].items.length, color: null, size: null };
      groups[key].items.push(item);
      items.push(item);
    }

    if (!groups.main) return null;
    if (!groups.gift) dialog.querySelector('[data-c-bundle-group="gift"]').hidden = true;
    return { groups, items, root };
  }

  // Matches on defaultName (the shop's default language), so it works whatever language the storefront is in.
  // The colour option isn't always called "Kleur" (the slip 3-pack calls it "Bundel"), so with two options the non-size one is the colour.
  function findOptionIndexes(product) {
    const names = product.options.map(option => option.defaultName || option.name);
    let colorIndex = product.options.findIndex(option => option.optionValues.some(value => value.swatch?.color));
    if (colorIndex === -1) colorIndex = names.findIndex(name => COLOR_OPTION_PATTERN.test(name));
    let sizeIndex = names.findIndex((name, index) => index !== colorIndex && SIZE_OPTION_PATTERN.test(name));
    if (product.options.length === 2) {
      if (colorIndex === -1 && sizeIndex !== -1) colorIndex = 1 - sizeIndex;
      if (sizeIndex === -1 && colorIndex !== -1) sizeIndex = 1 - colorIndex;
    }
    return { colorIndex, sizeIndex };
  }

  // name: shown and written to Kaching (storefront language); defaultName: looks up the design colour and order
  function sortColors(optionValues) {
    const colors = optionValues.map(value => {
      const key = (value.defaultName || value.name).toLowerCase();
      return { name: value.name, key, hex: SWATCH_COLORS[key] || value.swatch?.color || '#cccccc' };
    });
    const rank = color => {
      const index = COLOR_ORDER.indexOf(color.key);
      return index === -1 ? COLOR_ORDER.length : index;
    };
    return colors.map((color, index) => ({ color, index }))
      .sort((a, b) => rank(a.color) - rank(b.color) || a.index - b.index)
      .map(({ color }) => color);
  }

  // Light swatches (e.g. Wit) get a grey edge so they stay visible on white
  function isLight(hex) {
    const value = parseInt(hex.replace('#', '').padEnd(6, '0').slice(0, 6), 16);
    const luminance = (0.299 * (value >> 16) + 0.587 * ((value >> 8) & 255) + 0.114 * (value & 255)) / 255;
    return luminance > 0.9;
  }

  // Locale strings are rendered with [token] placeholders, see snippets/c-bundle-builder.liquid
  function text(element, key, values) {
    return fillText(element.dataset[key] || '', values);
  }

  function fillText(template, values = {}) {
    return template.replace(/\[(\w+)\]/g, (match, token) => (token in values ? values[token] : match));
  }

  // Shop money format, e.g. "€{{amount_with_comma_separator}}"
  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const [whole, decimals] = amount.split('.');
    const group = separator => whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (match, token) => ({
      amount: `${group(',')}.${decimals}`,
      amount_no_decimals: group(','),
      amount_with_comma_separator: `${group('.')},${decimals}`,
      amount_no_decimals_with_comma_separator: group('.'),
      amount_with_apostrophe_separator: `${group("'")}.${decimals}`
    })[token] || amount);
  }

  function parseJson(script) {
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function setSelect(row, optionName, value) {
    const select = [...row.querySelectorAll('select')].find(select => select.dataset.name === optionName);
    if (!select || value == null || select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function barText(bar, selector) {
    return bar?.querySelector(selector)?.textContent.trim() || '';
  }

  function setText(element, content) {
    if (element && element.textContent !== content) element.textContent = content;
  }

  // "€62,91" -> 62.91
  // Handles "€62,90" and "£62.90": the last separator followed by 1-2 digits is the decimal one
  function parsePrice(content) {
    const number = content.replace(/[^\d.,]/g, '');
    const decimal = number.match(/[.,](\d{1,2})$/);
    const whole = (decimal ? number.slice(0, decimal.index) : number).replace(/[.,]/g, '');
    return parseFloat(decimal ? `${whole}.${decimal[1]}` : whole);
  }

  function waitFor(condition, timeout = 3000) {
    return new Promise(resolve => {
      const start = Date.now();
      (function check() {
        if (condition()) return resolve(true);
        if (Date.now() - start > timeout) return resolve(false);
        setTimeout(check, 50);
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
